var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:[_vm.overlayClass || ''],attrs:{"id":"process-overlay"}},[_c('img',{staticClass:"process",attrs:{"src":require("@shared/assets/img/general/loading-white.svg"),"alt":"Processing"}}),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }